import React from 'react';
import PlayButtonIcon from '@/services/icons/play-button.svg';
import { OpenVideoOverlay } from '@/store/onboarding/actions';
import { useDispatch } from 'react-redux';
import { OnboardingVideoData } from '../../types';
import { Thumbnail, YoutubePreviewWrapper } from './styles';

const thumbnailAlt = 'YouTube Video Thumbnail';
const ariaLabel = 'Play Video';
const getThumbnailSrc = (videoId: string) => `https://img.youtube.com/vi/${videoId}/0.jpg`;

export const OnboardingVideoThumbnail = ({ videoId }: OnboardingVideoData) => {
    const dispatch = useDispatch();
    const onClickHandler = () => dispatch(OpenVideoOverlay({ videoId }));
    return (
        <YoutubePreviewWrapper onClick={onClickHandler} aria-label={ariaLabel}>
            <Thumbnail src={getThumbnailSrc(videoId)} alt={thumbnailAlt} />
            <PlayButtonIcon />
        </YoutubePreviewWrapper>
    );
};
